module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/engine.io-parser/~/isarray/index.js
 ** module id = 96
 ** module chunks = 1
 **/